import React, { type FC, type PropsWithChildren } from 'react';

import { Redirect as InternalRedirect } from '@reach/router';
import { withURL, isBrowser, isInternalURL } from '@lucid/utils';

import type { Lucid } from '../../types/types';

export interface RedirectProps {
  /** Will pass query params with the redirect */
  shouldPassQueryParams?: boolean;
  /** The URL to redirect to */
  href: string;
  /** The site product */
  product: Lucid.Site.Product;
  /** The language URL prefix */
  urlLangPrefix: Lucid.I18n.LanguagesURLPrefix;
}

const Redirect: FC<PropsWithChildren<RedirectProps>> = ({ href, shouldPassQueryParams, product, urlLangPrefix }) => {
  const url = withURL(href, { product, urlLangPrefix });

  let searchParams = '';

  if (shouldPassQueryParams) searchParams = window.location.search;

  if (isInternalURL(url, product)) return <InternalRedirect noThrow to={url} />;

  if (href && isBrowser()) window.location.replace(`${href}${searchParams}`);

  return <></>;
};

export default Redirect;
